<template>
  <div>
    {{ ActDescBtn }}
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Gestion de Transportes'"
          :show-absolute="false"
          :titulo="'Transportes'"
          @MethodEliminar="remove"
          @MethodGuardar="guardar"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row>
        <!-- Barra de busqueda --->
        <v-col v-show="BarraPrimariaAbrir" :max-height="this.windowSize.height - 96" cols="3">
          <div
            class="overflow-y-auto"
            v-bind:style="{
              'max-height': this.windowSize.height - 96 + 'px',
            }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!-- <v-navigation-drawer >  -->
                <div v-if="false" class="d-flex justify-center mb-2">
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      Ver
                    </v-btn>

                    <v-btn
                      color="teal darken-2"
                      dark
                      small
                      text
                      @click.prevent="
                        ;(dialogFiltros = true), (ObjTemTbDinam = JSON.parse(JSON.stringify(Modallfiltro)))
                      "
                    >
                      <i class="fa fa-search" style="font-size: 25px"></i>
                      Filtrar
                    </v-btn>
                  </v-btn-toggle>
                </div>

                <BarraDinamicaLimitePlus
                  :ContListSlot="[
                    { Text: 'Codigo', NomValue: 'codigo', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Nombre', NomValue: 'nombre', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Telefono', NomValue: 'telefono', Ctsl: 1, Type: 0, State: true },
                  ]"
                  :PropsList="transporteList"
                  :PropsNombre="'Transportes'"
                  :PropsSeachNombre="'Búsqueda por nombre o RNC'"
                  :TbPaginator="TbPaginator"
                  :TbTotalItem="totalItems"
                  :headers="[{ text: 'Código', value: 'secuencia' }]"
                  props-search
                  @CargarPaginacion="CargarPaginacion"
                  @EmitDAta="datostabla"
                />
              </template>
            </v-tooltip>
          </div>
        </v-col>
        <!-- fn Barra de busqueda --->

        <!-- Contenido central --->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <div class="px-2">
              <!---- Formulario ----->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card color="grey lighten-3">
                  <div class="px-2">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field v-model="transporte.codigo" dense label="Codigo" outlined readonly type="number">
                          <template v-slot:prepend>
                            <i class="fa fa-list-ol" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="transporte.rnc"
                          v-mask="'###-#######-#'"
                          :rules="[$rules.required, $rules.RulesCelRncValidar]"
                          dense
                          label="RNC *"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-id-card-o" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          v-model="transporte.nombre"
                          :rules="[$rules.required, this.rules.nombre]"
                          dense
                          label="Nombre *"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="transporte.telefono"
                          v-mask="'(###)###-####'"
                          dense
                          label="Telefono"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-phone" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </div>
                </v-card>
              </v-form>
              <!---- fn Formulario ----->
            </div>
          </v-app>
        </v-col>
        <!-- fn Contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!--  -->
    <v-dialog
      v-model="acti_tb_data"
      fullscreen
      hide-overlay
      label="myAlert"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="false"
                color="deep-purple accent-2"
                dark
                small
                v-on="on"
                @click.prevent="dialogimprimirListFilt = true"
              >
                <i class="fa fa-print" style="font-size: 25px"></i>
                Listado
              </v-btn>
            </template>
            <span>Imprimir Listado</span>
          </v-tooltip>

          <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="Modallfiltro.factura"
                autocomplete="off"
                hide-details
                label="Buscar"
                single-line
                type="number"
                @keyup="CargarListTb"
              >
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :footer-props="arrayPropiedases"
              :headers="[
                {
                  text: 'Secuencia',
                  value: 'secuencia',
                  width: 'auto',
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Autorizador',
                  value: 'autorizadoPor',
                  width: 'auto',
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Beneficiario',
                  value: 'beneficiario',
                  width: 'auto',
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'NO. Cierre',
                  value: 'numerocierre',
                  width: 'auto',
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Fecha',
                  value: 'fecha',
                  width: 'auto',
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Valor',
                  value: 'valor',
                  width: 'auto',
                  class: ['no-gutters black--text'],
                },
              ]"
              :items="transporteList"
              :items-per-page="TbPaginator.itemsPerPage"
              :page="TbPaginator.page"
              :pageCount="TbPaginator.pageCount"
              :search="Modallfiltro.factura"
              :server-items-length="totalItems"
              class="TbSize13"
              dense
              @pagination="cargarPaginacionAll"
              @click:row="datostabla"
            >
              <template v-slot:item.fecha="props">
                <span>{{ FormatoFecha(props.item.fecha) }}</span>
              </template>

              <template v-slot:item.valor="props">
                <span>{{ currencyFormatter(props.item.valor) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data todo general -->

    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'AnularCaja'" small @click.prevent="eliminar(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog
      v-model="dialogimprimirList"
      label="Modal Reporte Basico"
      max-height="50%"
      max-width="80%"
      persistent
      transition="fab-transition"
    >
      <ModalReporteBasico :Datos="datosImprecion" @DataReporteBasico="DDataReporteBasico" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->

    <!-- ------------------------------------------------------ Modal-Reportes-ModalReporteFiltros-->
    <v-dialog
      v-model="dialogimprimirListFilt"
      label="Modal agregar cuenta"
      max-height="50%"
      max-width="80%"
      persistent
      transition="fab-transition"
    >
      <!----------------------------------------------------------------- Cuerpo Reporte -->
      <v-card color="grey lighten-3">
        <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
          <v-avatar size="45" tile>
            <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px">
            <b>REPORTE ANULAR FACTURAS</b>
          </span>

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="dialogimprimirListFilt = false">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <hr />

        <v-container style="border: 1px solid #000000">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" md="6" sm="6">
                <v-text-field
                  v-model="datosImprecionAll.desde"
                  :rules="[$rules.required]"
                  dense
                  label="Desde*"
                  outlined
                  type="date"
                  @blur="BlurDesde"
                >
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px"></i>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6" sm="6">
                <!-------------------------------------------------- Hasta -->
                <v-text-field
                  v-model="datosImprecionAll.hasta"
                  :rules="[$rules.required]"
                  dense
                  label="Hasta*"
                  outlined
                  type="date"
                  @blur="BlurHasta"
                >
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px"></i>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <hr />

        <ModalReporteFiltros :Datos="datosImprecionAll" @DataReporteBasico="DDataReporteBasico" />
      </v-card>
      <!-------------------------------------------------------------------------------- Fn Cuerpo Reporte -->
    </v-dialog>

    <!--- Dialogo de confirmacion --->
    <DialogoConfirmacion ref="confirmDialog" />
    <!-- ------------------------------------------------------ fn Modal-Reportes-ModalReporteFiltros -->

    <div v-if="ejecucion" class="form-loading-indicator">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import Autonumeric from "../../components/AutoNumericNuevo"
  import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinamLimite"
  import BarraDinamicaLimite from "../../components/BarraDinamicaLimite"
  import { EventBus } from "../../event-bus.js"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteBasico from "../../components/ModalReporteBasico"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import { currencyFormatter, fechaNueva, FormatoFecha, getParamFecha, HoraFormatter } from "@/js/Funciones.js"
  import DialogoConfirmacion from "@/components/DialogoConfirmacion.vue"

  export default {
    components: {
      DialogoConfirmacion,
      BarraDinamicaLimite,
      BarraDinamicaLimitePlus,
      BarraBusqueda2,
      Autonumeric,
      ContenidoBase,
      ModalReporteBasico,
      ModalReporteFiltros,
    },

    mounted() {
      console.log("Mount-Inf")
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("emitAnular", this.datostabla)
      EventBus.$on("AnularNew", this.new)
      // EventBus.$on("AnularSave", this.save);
      EventBus.$on("AnularRemove", this.remove)
      EventBus.$on("AnularAnular", this.save)
      EventBus.$on("AnularPrintList", this.imprimirList)
      this.cargar()
    },

    created() {
      var json = {
        titulo: "Anular Facturas",
        descripcion: "permite Anular una factura",
        save: false,
        eliminar: false,
        anular: true,
        nuevo: true,
        imprimir: true,
        accion: ["AnularNew", "AnularSave", "AnularRemove", "AnularAnular", "AnularPrintList"],
      }
      // EventBus.$emit("anularBotonesAccion", json)
    },

    data() {
      return {
        windowSize: { width: "auto", height: "auto" },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        },

        RCliente: [],
        RVer: null,
        texAria: null,
        valid: true,

        anular: {
          documento: null,
          factura: 0,
          ncf: null,
          tipoAnulacion: null,
        },

        dialogimprimirListFilt: false,

        datosImprecionAll: {
          nombre: "ANULAR VALES",
          UrlImprimir: "/AnularFactura/ImprimirList",
          UrlExel: "/AnularFactura/ExcelList",
          UrlCorreo: "/AnularFactura/CorreoList",
          desde: new Date().toISOString().substr(0, 10),
          hasta: new Date().toISOString().substr(0, 10),
          documentos: null,
        },

        dialogimprimirList: false,
        datosImprecion: {
          nombre: "ANULAR VALES",
          UrlImprimir: "/AnularFactura/Imprimir/",
          UrlExel: "/AnularFactura/Excel/",
          UrlCorreo: "/AnularFactura/Correo/",
          codigo: 0,
          documento: 0,
        },

        dialogFiltros: false,

        Modallfiltro: {
          factura: null,
          cliente: null,
          Desde: null,
          Hasta: null,
        },

        beneficiarioList: [],

        filtros: {
          secuencia: null,
          beneficiario: "",
          fechaInicial: null,
          fechaFinal: null,
        },

        // Formulario
        transporteNuevo: {
          codigo: 0,
          nombre: "",
          rnc: "",
          telefono: "",
          activado: true,
        },

        transporte: {
          codigo: 0,
          nombre: "",
          rnc: "",
          telefono: "",
          activado: true,
        },

        rules: {
          nombre: (val) => (val && val.length > 3) || "Nombre debe tener minimo 3 caracteres",
          rnc: (val) => (val && val.length > 3) || "RNC debe tener minimo 3 caracteres",
        },

        // Listados
        transporteList: [],
        totalItems: 0,

        ObjTemTbDinam: null,
        List: [],
        TbTotalItem: 0,
        TbPaginator: {
          page: 1,
          itemsPerPage: 5,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },
        arrayPropiedases: {
          "items-per-page-options": [10, 15, 20, 50],
          "items-per-page-text": "Cantidad de Registros Por Paginas",
          showFirstLastPage: false,
        },
        headers: [{ text: "#Factura", value: "facturasventaPK.secuencia" }],

        slotlist: [
          {
            dt0: "facturasventaPK",
            dt1: "secuencia",
            dt2: null,
            dt3: 1,
            dt4: "#Factura:",
          },
          {
            dt0: "documentoFactura",
            dt1: "nombrecorto",
            dt2: null,
            dt3: 1,
            dt4: "Nombre corto:",
          },
          {
            dt0: "motivoAnular",
            dt1: null,
            dt2: null,
            dt3: 1,
            dt4: "Tipo de Anulacion:",
          },
          { dt0: "fecha", dt1: null, dt2: null, dt3: 2, dt4: "Fecha:" },
          { dt0: "valor", dt1: null, dt2: null, dt3: 5, dt4: "A pagar: $" },
          { dt0: "activada", dt1: null, dt2: null, dt3: 0.1, dt4: "Anulada" },
        ],

        list: [],
        search: "",
        acti_tb_data: false,

        limiteTotalRegistros: 0,
        paginator: {
          itemsPerPage: 15,
          pageStart: 1,
          page: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },

        ejecucion: false,
        aalert: {
          estado: false,
          color: null,
        },

        notif: {
          estado: false,
          nombre: "",
          Exec: "",
        },

        disabled: false,

        BarraPrimariaAbrir: false,
      }
    },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      fechaNueva,
      getParamFecha,
      cargarCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/clientes/findCombo/A/25", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.RCliente = res.data))
      },

      CbFilcliente(e) {
        this.RCliente = []
        if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {
              this.RCliente = res.data
            })
        }
      },

      // Al verificar si el cliente es nulo, si es nulo, establece el cliente en una cadena vacía.
      SelctCbCliente() {
        if (this.Modallfiltro.cliente == null) {
          this.Modallfiltro.cliente = ""
        }

        if (this.Modallfiltro.cliente.codigo == undefined) {
          this.alerta("Seleccione un cliente", "error")
          this.Modallfiltro.cliente = ""

          //qlq2

          return
        }
      },

      cargar() {
        //  this.$axios.post(this.$hostname + this.$hName +'/services/AnularFactura/totalRegistrosFacturasAnuladas', {})
        // .then(res => (this.limiteTotalRegistros = res.data.totalRegistros, this.filtro()));
      },

      fecFormatter(params) {
        if (params != null) {
          if (params.length > 0) {
            return params.substring(8, 10) + "-" + params.substring(5, 7) + "-" + params.substring(0, 4)
          }
        }
      },

      // Abriendo una la barra de datos principal.
      abrirTabla() {
        this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir

        if (this.abrirTablaDinamica == true) {
          this.Limpiarfiltro()
        }
      },

      BlurDesde() {
        if (this.datosImprecionAll.desde.toString().length == 0) {
          this.datosImprecionAll.desde = new Date().toISOString().substr(0, 10)
        }
      },

      BlurHasta() {
        if (this.datosImprecionAll.hasta.toString().length == 0) {
          this.datosImprecionAll.hasta = new Date().toISOString().substr(0, 10)
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e

          this.newnuevo()
        }

        if (l == "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e

          EventBus.$emit("loading", false)
        }
      },

      // Limpia el formulario.
      newnuevo() {
        Object.assign(this.transporte, this.transporteNuevo)
        this.$refs.form.resetValidation()
        this.ejecucion = false
      },

      // Llamar a una función que se define en la sección de métodos del componente Vue para imprimir reporte.
      imprimirList() {
        this.dialogimprimirList = true
        this.datosImprecion.codigo = this.anular.factura
        this.datosImprecion.documento = this.anular.documento.codigo
      },
      DDataReporteBasico(e) {
        this.dialogimprimirList = e
      },

      // Envío de una solicitud POST al servidor y guarda la anulacion.
      guardar() {
        if (this.$refs.form.validate()) {
          if (this.transporte.codigo === 0) {
            this.save()
          } else {
            this.modificar()
          }
        } else {
          this.alerta("los campos en rojo son requeridos", "error")
        }
      },

      save() {
        this.$axios
          .post(this.$hostname + this.$hName + "/transportes", this.transporte, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Guardado exitoso!", "bien")
            this.CargarListTb()
          })
          .catch((error) => {
            console.error(error)
            if (error.response.status === 409) {
              this.alerta(error.response.data, "error")
            }
          })
      },

      modificar() {
        this.$axios
          .put(this.$hostname + this.$hName + "/transportes", this.transporte, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Modificacion exitosa!", "bien")
            this.CargarListTb()
          })
          .catch((error) => {
            console.error(error)
            if (error.response.status === 409) {
              this.alerta(error.response.data, "error")
            }
          })
      },

      async remove() {
        if (!(await this.$refs.confirmDialog.show())) return

        let codigo = this.transporte.codigo
        this.$axios
          .delete(this.$hostname + this.$hName + `/transportes/${codigo}`, this.transporte, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Eliminacion exitosa!", "bien")
            this.CargarListTb()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al eliminar!", "error")
          })
      },

      eliminar() {},

      // Se llama cuando se hace clic en una fila de la tabla.
      datostabla(e) {
        Object.assign(this.transporte, e)
        this.acti_tb_data = false
      },

      // async filtro() {
      //   var obj = {
      //     datos: JSON.parse(JSON.stringify(this.anular)),
      //     usuario: JSON.parse(JSON.stringify(this.$user)),
      //     descripcion: this.search,
      //     ultimoRegistro: this.paginator.pageStart,
      //     paginacion: this.paginator.page,
      //     limite: this.paginator.itemsPerPage,
      //   }
      // },

      // Un metodo que se llama cuando se hace clic en un boton y muestra un modal con todo los registro.
      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.Limpiarfiltro()
      },

      // Limpieza del filtro y recarga los datos de la tabla.
      Limpiarfiltro() {
        var Pg = {
          itemsLength: this.TbPaginator.itemsLength,
          itemsPerPage: this.TbPaginator.itemsPerPage,
          page: 1,
          pageCount: 1,
          pageStart: 0,
          pageStop: this.TbPaginator.itemsPerPage,
        }

        this.filtros = {
          secuencia: null,
          beneficiario: "",
          fechaInicial: null,
          fechaFinal: null,
        }

        this.TbPaginator = JSON.parse(JSON.stringify(Pg))
        this.CargarListTb()
        this.dialogFiltros = false
      },

      // Una función que se llama cuando el usuario hace clic en el botón de búsqueda y ejecuta un a api retornando los datos.
      BuscarFiltros() {
        var Pg = {
          itemsLength: this.TbPaginator.itemsLength,
          itemsPerPage: this.TbPaginator.itemsPerPage,
          page: 1,
          pageCount: 1,
          pageStart: 0,
          pageStop: this.TbPaginator.itemsPerPage,
        }

        this.TbPaginator = JSON.parse(JSON.stringify(Pg))
        this.CargarListTb()
        this.dialogFiltros = false
      },

      // Un metodo que se llama cuando el usuario cambia la cantidad de elementos por página en el
      // componente de paginación.
      cargarPaginacionAll(e) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.CargarPaginacion(e, this.Modallfiltro.factura)
      },

      // Un metodo que se llama cuando el usuario cambia la página de la tabla.
      CargarPaginacion(e, s) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.TbPaginator = JSON.parse(JSON.stringify(e))
        this.search = s
        this.CargarListTb()
      },

      // Obtener los datos de la lista
      CargarListTb() {
        this.$axios
          .get(this.$hostname + this.$hName + "/transportes", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              size: this.TbPaginator.itemsPerPage,
              page: this.TbPaginator.pageStart / 10,
              search: this.search,
            },
          })
          .then((res) => {
            console.log(res)
            this.transporteList = res.data.content
            this.totalItems = res.data.totalElements
          })
          .catch((error) => {
            console.error(error)
          })
      },
    },

    computed: {
      ActDescBtn() {
        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
      },
    },

    watch: {
      "transporte.codigo"(value) {
        this.EstadoBtn.eliminar = value !== 0
      },
    },
  }
</script>

<style>
  .form-loading-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent;
    padding: 20px;
    border-radius: 4px;
    z-index: 1;
  }
</style>
